import { Component } from '@angular/core';
import { LabDialogsComponent } from '../lab-dialogs/lab-dialogs.component';
import { LabPopoversComponent } from '../lab-popovers/lab-popovers.component';
import { LabNotificationsComponent } from '../lab-notifications/lab-notifications.component';
import { LabTooltipsComponent } from '../lab-tooltips/lab-tooltips.component';

/**
 * Lab overlay host bundle.
 *
 * This mirrors Sól's overlay aggregate, but every visible host is the lab
 * version so the playground shell can swap to one component when useful.
 */
@Component({
  selector: 'lab-overlays',
  standalone: true,
  imports: [LabDialogsComponent, LabPopoversComponent, LabNotificationsComponent, LabTooltipsComponent],
  template: `
    <lab-dialogs />
    <lab-popovers />
    <lab-notifications />
    <lab-tooltips />
  `,
})
export class LabOverlaysComponent {}
